class CountryCodeDirective {
  static directive() {
    return {
      replace:true,
      scope: {
        model: '=',
        form: '='
      },
      template: `
      <md-input-container flex="33">
        <label for="country-code">{{ 'COMMONS.COUNTRY_CODE' | translate }}</label>
        <md-select id="country-code" ng-model="model" name="countryCode">
          <md-option ng-repeat="code in codes" ng-value="code.code">
            <div class="country-code-selector-value">
              <img ng-src="{{code.flag}}" class="country-code-selector-image"> {{ code.code }}
            </div>
          </md-option>
        </md-select>
        <div ng-messages="form.countryCode.$error" multiple md-auto-hide="false">
          <div ng-message="valid">
            {{ 'COMMONS.COUNTRY_CODE_INVALID' | translate }}
          </div>
        </div>
      </md-input-container>
      `,
      controller: function ($scope) {
        'ngInject';

        $scope.codes = [
          {code: "+1", name: "USA", flag: require("../../../assets/flags/usa.png")},
          {code: "+48", name: "PL", flag: require("../../../assets/flags/poland.png")},
          {code: "+243", name: "COD", flag: require("../../../assets/flags/congo.png")}
        ];
      }
    }
  };
}

export default CountryCodeDirective.directive;


// WEBPACK FOOTER //
// ./src/users/directives/country-code.js